/// <reference types="@emotion/react/types/css-prop" />
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import tz from 'moment-timezone'
import React from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import 'url-search-params-polyfill'

import Root from 'Root'
import { appConfig } from 'utils/app-config'
import { isProductionEnvironment } from 'utils/environment'

tz()

const { BRANCH, COMMIT_REF, REACT_APP_CIRCLE_BRANCH, REACT_APP_CIRCLE_SHA1 } =
  process.env

const { RAVEN_DSN } = appConfig.getState()

if (isProductionEnvironment()) {
  try {
    Sentry.init({
      dsn: RAVEN_DSN,
      environment: REACT_APP_CIRCLE_BRANCH || BRANCH || 'development',
      release: REACT_APP_CIRCLE_SHA1 || COMMIT_REF,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
      ignoreErrors: [
        // error will cause a retry and still results in a usable application, so don't log this EN-2251
        'Chunk Load Error',
        // benign/ignorable error according to spec author
        // https://stackoverflow.com/a/50387233
        'ResizeObserver loop limit exceeded'
      ]
    })
  } catch (err) {
    console.error('Unable to initialize Sentry:', err)
  }
}

const rootEl = document.getElementById('root')

Modal.setAppElement(rootEl)
Modal.defaultStyles.content = null
Modal.defaultStyles.overlay = null

ReactDOM.render(<Root />, rootEl)
